import { axiosGet } from "../../apis/useAxios";

/**
 * GET UserAccess/my-session: the logged-in user's session for the top-right menu —
 * { currentIp, sessionStartedAt, lastLoginAt, lastLoginIp, network: "open" | "inside" | "outsideAllowed" | "systemUser" }.
 * Resolves to null when it cannot be loaded (the menu then shows only what the login stored).
 */
export async function getMySession() {
  try {
    const response = await axiosGet("UserAccess/my-session", {
      userName: sessionStorage.getItem("session_userName") ?? "",
      sessionId: sessionStorage.getItem("session_sessionId") ?? "",
    });
    return response?.isSuccess ? (response.payload ?? null) : null;
  } catch {
    return null;
  }
}
